<template>
  <div class="news-page">
    <div class="toolbar">
      <el-input
        v-model="keyword"
        placeholder="搜索标题/内容"
        clearable
        class="search"
      />
      <el-button type="primary" @click="loadList">搜索</el-button>
    </div>
    <el-table
      ref="tableRef"
      :data="list"
      stripe
      style="width:100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="title" label="新闻标题" />
      <el-table-column prop="source" label="来源" width="120" />
      <el-table-column prop="published_at" label="时间" width="160" />
      <el-table-column label="操作" width="160">
        <template #default="{row}">
          <el-button size="small" type="primary" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      :current-page="pagination.page"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="prev, pager, next"
      @current-change="pageChange"/>
    <div class="batch-bar">
      <el-button @click="toggleAll">全选</el-button>
      <el-button type="danger" @click="batchRemove">批量删除</el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, shallowRef } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import stockClient from '../../utils/stockClient';

const router = useRouter();
const list = ref([]);
const pagination = ref({ page: 1, pageSize: 30, total: 0 });
const keyword = ref('');
const tableRef = shallowRef();
const selection = ref([]);

const loadList = async () => {
  const params = {
    page: pagination.value.page,
    page_size: pagination.value.pageSize,
    keyword: keyword.value
  };
  try {
    const res = await stockClient.get('/news/list', { params });
    const payload = res.data?.data || {};
    list.value = payload.data || [];
    pagination.value.page = payload.page || 1;
    pagination.value.pageSize = payload.page_size || pagination.value.pageSize;
    pagination.value.total = payload.total || 0;
  } catch (e) {
    ElMessage.error(e.toString());
  }
};

const pageChange = (p) => {
  pagination.value.page = p;
  loadList();
};

const edit = (row) => {
  router.push(`/stock/news/edit/${row.id}`);
};

const remove = async (row) => {
  try {
    await stockClient.get('/news/delete', { params: { id: row.id } });
    ElMessage.success('删除成功');
    loadList();
  } catch (e) {
    ElMessage.error(e.toString());
  }
};

const handleSelectionChange = (val) => {
  selection.value = val;
};

const toggleAll = () => {
  if (tableRef.value) tableRef.value.toggleAllSelection();
};

const batchRemove = async () => {
  const ids = selection.value.map((v) => v.id);
  if (!ids.length) {
    ElMessage.warning('请选择要删除的记录');
    return;
  }
  try {
    await stockClient.post('/news/delete-multiple', { ids });
    ElMessage.success('删除成功');
    selection.value = [];
    loadList();
  } catch (e) {
    ElMessage.error(e.toString());
  }
};

onMounted(loadList);
</script>

<style scoped>
.news-page {
  padding: 20px;
}
.toolbar {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
}
.search {
  width: 200px;
}
.pager {
  margin-top: 15px;
  text-align: right;
}
.batch-bar {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}
</style>
